import {
  COLORS,
  DIAGRAMS
} from './constants.js';
import { hasArrayItems } from '../arrays.js';

export function buildDiagramDefinition(type, data = {}) {
  const definition = DIAGRAMS[type] || fallbackDefinition(type);

  if (!hasArrayItems(data.nodes)) return definition;

  return {
    label: data.label || definition.label,
    nodes: data.nodes.map((node, index) => ({
      id: node.id || `node-${index + 1}`,
      label: node.label || `Step ${index + 1}`,
      phase: node.phase || `Step ${index + 1}`,
      description: node.description || node.desc || '',
      x: Number(node.x) || 120 + (index * 180),
      y: Number(node.y) || (index % 2 === 0 ? 150 : 95),
      color: node.color || COLORS.brand900
    })),
    connections: hasArrayItems(data.connections)
      ? data.connections.map(connection => [connection.from, connection.to, connection.dashed])
      : definition.connections
  };
}

function fallbackDefinition(type) {
  return {
    label: type ? `${type.replaceAll('_', ' ')} diagram` : 'Diagram unavailable',
    nodes: [],
    connections: []
  };
}
